export const shopifyAppVersion = 1;

export const abandonedCheckoutTags = [
  { value: "{OrderPrice}", label: "Order Price" },
  { value: "{OrderCurrency}", label: "Order Currency" },
  { value: "{OrderItemCount}", label: "Order Item Count" },
  { value: "{FirstName}", label: "First Name" },
  { value: "{LastName}", label: "Last Name" },
  { value: "{Country}", label: "Country" },
  { value: "{City}", label: "City" },
  { value: "{Province}", label: "Province" },
  { value: "{FullAddress}", label: "Full Address" },
  { value: "{CheckoutUrl}", label: "Checkout Url" },
  { value: "{ShopName}", label: "Shop Name" },
  { value: "{DiscountCode}", label: "Discount Code" }
];

export const shippingConfirmationTags = [
  { value: "{OrderPrice}", label: "Order Price" },
  { value: "{OrderCurrency}", label: "Order Currency" },
  { value: "{OrderItemCount}", label: "Order Item Count" },
  { value: "{FirstName}", label: "First Name" },
  { value: "{LastName}", label: "Last Name" },
  { value: "{Country}", label: "Country" },
  { value: "{City}", label: "City" },
  { value: "{Province}", label: "Province" },
  { value: "{FullAddress}", label: "Full Address" },
  { value: "{ShopName}", label: "Shop Name" },
  { value: "{ShopUrl}", label: "Shop Url" },
  { value: "{OrderNumber}", label: "Order Number" },
  { value: "{OrderStatusUrl}", label: "Order Status URL" },
  { value: "{TrackingNumber}", label: "Tracking Number" },
  { value: "{TrackingUrl}", label: "Tracking URL" },
  { value: "{ShippingCompany}", label: "Shipping Company" },
  { value: "{DiscountCode}", label: "Discount Code" }
];
export const defaultTags = [
  { value: "{FirstName}", label: "First Name" },
  { value: "{LastName}", label: "Last Name" },
  { value: "{Country}", label: "Country" },
  { value: "{City}", label: "City" },
  { value: "{Province}", label: "Province" },
  { value: "{FullAddress}", label: "Full Address" },
  { value: "{ShopName}", label: "Shop Name" },
  { value: "{ShopUrl}", label: "Shop Url" },
  { value: "{DiscountCode}", label: "Discount Code" }
];

export const conversionHeaders = [
  { text: "Customer", value: "DIMENSION_CUSTOMER" },
  { text: "Product", value: "DIMENSION_PRODUCT" },
  { text: "Product + Variant", value: "DIMENSION_PRODUCT_VARIANT" },
  { text: "SKU", value: "DIMENSION_SKU" }
];
export const dateRanges = [
  { text: "1 day", value: 86400 },
  { text: "2 days", value: 172800 },
  { text: "3 days", value: 259200 },
  { text: "1 week", value: 604800 },
  { text: "2 weeks", value: 1209600 },
  { text: "3 weeks", value: 1814400 },
  { text: "1 month", value: 2419200 },
  { text: "2 months", value: 5256000 }
];

export const reportsMessagesHeaders = [
  {
    text: "Full Name",
    value: "fullName"
  },
  {
    text: "Phone Number",
    value: "phoneNumber"
  },
  {
    text: "Message",
    value: "message"
  },
  {
    text: "Send Date",
    value: "sendDate"
  },
  {
    text: "Click Count",
    value: "clickCount"
  },
  {
    text: "Revenue",
    value: "revenue"
  }
];

export const reportsClicksHeaders = [
  {
    text: "Url",
    value: "url"
  },
  {
    text: "Click Count",
    value: "clickCount"
  },
  {
    text: "Unique Click Count",
    value: "uniqueClickCount"
  }
];

export const reportsConversionsHeaders = [
  {
    text: "Product + Variant",
    value: "productVariant"
  },
  {
    text: "Orders",
    value: "orders"
  },
  {
    text: "Revenue",
    value: "revenue"
  }
];

export const reportsAutomationsHeaders = [
  {
    text: "Type",
    value: "type"
  },
  {
    text: "Status",
    value: "status"
  },
  {
    text: "Revenue",
    value: "revenue"
  }
];

export const reportsLiveStreamHeaders = [
  {
    text: "Event",
    value: "event"
  },
  {
    text: "Date",
    value: "date"
  }
];

export const reportsLatestCampaignHeaders = [
  {
    text: "Name",
    value: "name"
  },
  {
    text: "Message",
    value: "message"
  },
  {
    text: "Status",
    value: "status"
  },
  {
    text: "Revenue",
    value: "revenue"
  }
];

export const expiryTimeOptions = [
  { text: "1 day", value: "86400s" },
  { text: "2 days", value: "172800s" },
  { text: "3 days", value: "259200s" },
  { text: "1 week", value: "604800s" },
  { text: "2 weeks", value: "1209600s" },
  { text: "3 weeks", value: "1814400s" },
  { text: "1 month", value: "2419200s" },
  { text: "No expiry", value: "null" }
];

export const smartSendingOptions = [
  { text: "0 seconds", value: "0s" },
  { text: "10 minutes", value: "600s" },
  { text: "3 hours", value: "10800s" },
  { text: "6 hours", value: "21600s" },
  { text: "12 hours", value: "43200s" },
  { text: "16 hours", value: "57600s" },
  { text: "24 hours", value: "86400s" }
];

export const abandonedCheckoutOptions = [
  { text: "5 minutes", value: "300s" },
  { text: "10 minutes", value: "600s" },
  { text: "20 minutes", value: "1200s" },
  { text: "30 minutes", value: "1800s" },
  { text: "60 minutes", value: "3600s" },
  { text: "3 hours", value: "10800s" },
  { text: "6 hours", value: "21600s" },
  { text: "12 hours", value: "43200s" },
  { text: "24 hours", value: "86400s" },
  { text: "48 hours", value: "172800s" }
];

export const reactivationOptions = [
  { text: "1 month", value: "2628000s" },
  { text: "2 months", value: "5256000s" },
  { text: "3 months", value: "7776000s" },
  { text: "4 months", value: "10512000s" },
  { text: "5 months", value: "13140000s" },
  { text: "6 months", value: "15768000s" },
  { text: "9 months", value: "23652000s" },
  { text: "12 months", value: "31536000s" }
];

export const shippingOptions = [
  { text: "Immediately", value: "0s" },
  { text: "1 day", value: "86400s" },
  { text: "2 days", value: "172800s" },
  { text: "3 days", value: "259200s" },
  { text: "5 days", value: "432000s" },
  { text: "7 days", value: "604800s" },
  { text: "14 days", value: "1209600s" },
  { text: "21 days", value: "1814400s" }
];

// List of all countries in a simple list / array.
export const countryList = [
  {
    text: "Afghanistan",
    value: "Afghanistan"
  },
  {
    text: "Åland Islands",
    value: "Åland Islands"
  },
  {
    text: "Albania",
    value: "Albania"
  },
  {
    text: "Algeria",
    value: "Algeria"
  },
  {
    text: "Andorra",
    value: "Andorra"
  },
  {
    text: "Angola",
    value: "Angola"
  },
  {
    text: "Anguilla",
    value: "Anguilla"
  },
  {
    text: "Antigua & Barbuda",
    value: "Antigua & Barbuda"
  },
  {
    text: "Argentina",
    value: "Argentina"
  },
  {
    text: "Armenia",
    value: "Armenia"
  },
  {
    text: "Aruba",
    value: "Aruba"
  },
  {
    text: "Australia",
    value: "Australia"
  },
  {
    text: "Austria",
    value: "Austria"
  },
  {
    text: "Azerbaijan",
    value: "Azerbaijan"
  },
  {
    text: "Bahamas",
    value: "Bahamas"
  },
  {
    text: "Bahrain",
    value: "Bahrain"
  },
  {
    text: "Bangladesh",
    value: "Bangladesh"
  },
  {
    text: "Barbados",
    value: "Barbados"
  },
  {
    text: "Belarus",
    value: "Belarus"
  },
  {
    text: "Belgium",
    value: "Belgium"
  },
  {
    text: "Belize",
    value: "Belize"
  },
  {
    text: "Benin",
    value: "Benin"
  },
  {
    text: "Bermuda",
    value: "Bermuda"
  },
  {
    text: "Bhutan",
    value: "Bhutan"
  },
  {
    text: "Bolivia",
    value: "Bolivia"
  },
  {
    text: "Bosnia & Herzegovina",
    value: "Bosnia & Herzegovina"
  },
  {
    text: "Botswana",
    value: "Botswana"
  },
  {
    text: "Bouvet Island",
    value: "Bouvet Island"
  },
  {
    text: "Brazil",
    value: "Brazil"
  },
  {
    text: "British Indian Ocean Territory",
    value: "British Indian Ocean Territory"
  },
  {
    text: "British Virgin Islands",
    value: "British Virgin Islands"
  },
  {
    text: "Brunei",
    value: "Brunei"
  },
  {
    text: "Bulgaria",
    value: "Bulgaria"
  },
  {
    text: "Burkina Faso",
    value: "Burkina Faso"
  },
  {
    text: "Burundi",
    value: "Burundi"
  },
  {
    text: "Cambodia",
    value: "Cambodia"
  },
  {
    text: "Cameroon",
    value: "Cameroon"
  },
  {
    text: "Canada",
    value: "Canada"
  },
  {
    text: "Cape Verde",
    value: "Cape Verde"
  },
  {
    text: "Caribbean Netherlands",
    value: "Caribbean Netherlands"
  },
  {
    text: "Cayman Islands",
    value: "Cayman Islands"
  },
  {
    text: "Central African Republic",
    value: "Central African Republic"
  },
  {
    text: "Chad",
    value: "Chad"
  },
  {
    text: "Chile",
    value: "Chile"
  },
  {
    text: "China",
    value: "China"
  },
  {
    text: "Christmas Island",
    value: "Christmas Island"
  },
  {
    text: "Cocos (Keeling) Islands",
    value: "Cocos (Keeling) Islands"
  },
  {
    text: "Colombia",
    value: "Colombia"
  },
  {
    text: "Comoros",
    value: "Comoros"
  },
  {
    text: "Congo - Brazzaville",
    value: "Congo - Brazzaville"
  },
  {
    text: "Congo - Kinshasa",
    value: "Congo - Kinshasa"
  },
  {
    text: "Cook Islands",
    value: "Cook Islands"
  },
  {
    text: "Costa Rica",
    value: "Costa Rica"
  },
  {
    text: "Croatia",
    value: "Croatia"
  },
  {
    text: "Cuba",
    value: "Cuba"
  },
  {
    text: "Curaçao",
    value: "Curaçao"
  },
  {
    text: "Cyprus",
    value: "Cyprus"
  },
  {
    text: "Czechia",
    value: "Czechia"
  },
  {
    text: "Côte d’Ivoire",
    value: "Côte d’Ivoire"
  },
  {
    text: "Denmark",
    value: "Denmark"
  },
  {
    text: "Djibouti",
    value: "Djibouti"
  },
  {
    text: "Dominica",
    value: "Dominica"
  },
  {
    text: "Dominican Republic",
    value: "Dominican Republic"
  },
  {
    text: "Ecuador",
    value: "Ecuador"
  },
  {
    text: "Egypt",
    value: "Egypt"
  },
  {
    text: "El Salvador",
    value: "El Salvador"
  },
  {
    text: "Equatorial Guinea",
    value: "Equatorial Guinea"
  },
  {
    text: "Eritrea",
    value: "Eritrea"
  },
  {
    text: "Estonia",
    value: "Estonia"
  },
  {
    text: "Eswatini",
    value: "Eswatini"
  },
  {
    text: "Ethiopia",
    value: "Ethiopia"
  },
  {
    text: "Falkland Islands",
    value: "Falkland Islands"
  },
  {
    text: "Faroe Islands",
    value: "Faroe Islands"
  },
  {
    text: "Fiji",
    value: "Fiji"
  },
  {
    text: "Finland",
    value: "Finland"
  },
  {
    text: "France",
    value: "France"
  },
  {
    text: "French Guiana",
    value: "French Guiana"
  },
  {
    text: "French Polynesia",
    value: "French Polynesia"
  },
  {
    text: "French Southern Territories",
    value: "French Southern Territories"
  },
  {
    text: "Gabon",
    value: "Gabon"
  },
  {
    text: "Gambia",
    value: "Gambia"
  },
  {
    text: "Georgia",
    value: "Georgia"
  },
  {
    text: "Germany",
    value: "Germany"
  },
  {
    text: "Ghana",
    value: "Ghana"
  },
  {
    text: "Gibraltar",
    value: "Gibraltar"
  },
  {
    text: "Greece",
    value: "Greece"
  },
  {
    text: "Greenland",
    value: "Greenland"
  },
  {
    text: "Grenada",
    value: "Grenada"
  },
  {
    text: "Guadeloupe",
    value: "Guadeloupe"
  },
  {
    text: "Guatemala",
    value: "Guatemala"
  },
  {
    text: "Guernsey",
    value: "Guernsey"
  },
  {
    text: "Guinea",
    value: "Guinea"
  },
  {
    text: "Guinea-Bissau",
    value: "Guinea-Bissau"
  },
  {
    text: "Guyana",
    value: "Guyana"
  },
  {
    text: "Haiti",
    value: "Haiti"
  },
  {
    text: "Heard & McDonald Islands",
    value: "Heard & McDonald Islands"
  },
  {
    text: "Honduras",
    value: "Honduras"
  },
  {
    text: "Hong Kong SAR China",
    value: "Hong Kong SAR China"
  },
  {
    text: "Hungary",
    value: "Hungary"
  },
  {
    text: "Iceland",
    value: "Iceland"
  },
  {
    text: "India",
    value: "India"
  },
  {
    text: "Indonesia",
    value: "Indonesia"
  },
  {
    text: "Iran",
    value: "Iran"
  },
  {
    text: "Iraq",
    value: "Iraq"
  },
  {
    text: "Ireland",
    value: "Ireland"
  },
  {
    text: "Isle of Man",
    value: "Isle of Man"
  },
  {
    text: "Israel",
    value: "Israel"
  },
  {
    text: "Italy",
    value: "Italy"
  },
  {
    text: "Jamaica",
    value: "Jamaica"
  },
  {
    text: "Japan",
    value: "Japan"
  },
  {
    text: "Jersey",
    value: "Jersey"
  },
  {
    text: "Jordan",
    value: "Jordan"
  },
  {
    text: "Kazakhstan",
    value: "Kazakhstan"
  },
  {
    text: "Kenya",
    value: "Kenya"
  },
  {
    text: "Kiribati",
    value: "Kiribati"
  },
  {
    text: "Kosovo",
    value: "Kosovo"
  },
  {
    text: "Kuwait",
    value: "Kuwait"
  },
  {
    text: "Kyrgyzstan",
    value: "Kyrgyzstan"
  },
  {
    text: "Laos",
    value: "Laos"
  },
  {
    text: "Latvia",
    value: "Latvia"
  },
  {
    text: "Lebanon",
    value: "Lebanon"
  },
  {
    text: "Lesotho",
    value: "Lesotho"
  },
  {
    text: "Liberia",
    value: "Liberia"
  },
  {
    text: "Libya",
    value: "Libya"
  },
  {
    text: "Liechtenstein",
    value: "Liechtenstein"
  },
  {
    text: "Lithuania",
    value: "Lithuania"
  },
  {
    text: "Luxembourg",
    value: "Luxembourg"
  },
  {
    text: "Macao SAR China",
    value: "Macao SAR China"
  },
  {
    text: "Madagascar",
    value: "Madagascar"
  },
  {
    text: "Malawi",
    value: "Malawi"
  },
  {
    text: "Malaysia",
    value: "Malaysia"
  },
  {
    text: "Maldives",
    value: "Maldives"
  },
  {
    text: "Mali",
    value: "Mali"
  },
  {
    text: "Malta",
    value: "Malta"
  },
  {
    text: "Martinique",
    value: "Martinique"
  },
  {
    text: "Mauritania",
    value: "Mauritania"
  },
  {
    text: "Mauritius",
    value: "Mauritius"
  },
  {
    text: "Mayotte",
    value: "Mayotte"
  },
  {
    text: "Mexico",
    value: "Mexico"
  },
  {
    text: "Moldova",
    value: "Moldova"
  },
  {
    text: "Monaco",
    value: "Monaco"
  },
  {
    text: "Mongolia",
    value: "Mongolia"
  },
  {
    text: "Montenegro",
    value: "Montenegro"
  },
  {
    text: "Montserrat",
    value: "Montserrat"
  },
  {
    text: "Morocco",
    value: "Morocco"
  },
  {
    text: "Mozambique",
    value: "Mozambique"
  },
  {
    text: "Myanmar (Burma)",
    value: "Myanmar (Burma)"
  },
  {
    text: "Namibia",
    value: "Namibia"
  },
  {
    text: "Nauru",
    value: "Nauru"
  },
  {
    text: "Nepal",
    value: "Nepal"
  },
  {
    text: "Netherlands",
    value: "Netherlands"
  },
  {
    text: "Netherlands Antilles",
    value: "Netherlands Antilles"
  },
  {
    text: "New Caledonia",
    value: "New Caledonia"
  },
  {
    text: "New Zealand",
    value: "New Zealand"
  },
  {
    text: "Nicaragua",
    value: "Nicaragua"
  },
  {
    text: "Niger",
    value: "Niger"
  },
  {
    text: "Nigeria",
    value: "Nigeria"
  },
  {
    text: "Niue",
    value: "Niue"
  },
  {
    text: "Norfolk Island",
    value: "Norfolk Island"
  },
  {
    text: "North Korea",
    value: "North Korea"
  },
  {
    text: "North Macedonia",
    value: "North Macedonia"
  },
  {
    text: "Norway",
    value: "Norway"
  },
  {
    text: "Oman",
    value: "Oman"
  },
  {
    text: "Pakistan",
    value: "Pakistan"
  },
  {
    text: "Palestinian Territories",
    value: "Palestinian Territories"
  },
  {
    text: "Panama",
    value: "Panama"
  },
  {
    text: "Papua New Guinea",
    value: "Papua New Guinea"
  },
  {
    text: "Paraguay",
    value: "Paraguay"
  },
  {
    text: "Peru",
    value: "Peru"
  },
  {
    text: "Philippines",
    value: "Philippines"
  },
  {
    text: "Pitcairn Islands",
    value: "Pitcairn Islands"
  },
  {
    text: "Poland",
    value: "Poland"
  },
  {
    text: "Portugal",
    value: "Portugal"
  },
  {
    text: "Qatar",
    value: "Qatar"
  },
  {
    text: "Réunion",
    value: "Réunion"
  },
  {
    text: "Romania",
    value: "Romania"
  },
  {
    text: "Russia",
    value: "Russia"
  },
  {
    text: "Rwanda",
    value: "Rwanda"
  },
  {
    text: "Samoa",
    value: "Samoa"
  },
  {
    text: "San Marino",
    value: "San Marino"
  },
  {
    text: "São Tomé & Príncipe",
    value: "São Tomé & Príncipe"
  },
  {
    text: "Saudi Arabia",
    value: "Saudi Arabia"
  },
  {
    text: "Senegal",
    value: "Senegal"
  },
  {
    text: "Serbia",
    value: "Serbia"
  },
  {
    text: "Seychelles",
    value: "Seychelles"
  },
  {
    text: "Sierra Leone",
    value: "Sierra Leone"
  },
  {
    text: "Singapore",
    value: "Singapore"
  },
  {
    text: "Sint Maarten",
    value: "Sint Maarten"
  },
  {
    text: "Slovakia",
    value: "Slovakia"
  },
  {
    text: "Slovenia",
    value: "Slovenia"
  },
  {
    text: "Solomon Islands",
    value: "Solomon Islands"
  },
  {
    text: "Somalia",
    value: "Somalia"
  },
  {
    text: "South Africa",
    value: "South Africa"
  },
  {
    text: "South Georgia & South Sandwich Islands",
    value: "South Georgia & South Sandwich Islands"
  },
  {
    text: "South Korea",
    value: "South Korea"
  },
  {
    text: "South Sudan",
    value: "South Sudan"
  },
  {
    text: "Spain",
    value: "Spain"
  },
  {
    text: "Sri Lanka",
    value: "Sri Lanka"
  },
  {
    text: "St. Barthélemy",
    value: "St. Barthélemy"
  },
  {
    text: "St. Helena",
    value: "St. Helena"
  },
  {
    text: "St. Kitts & Nevis",
    value: "St. Kitts & Nevis"
  },
  {
    text: "St. Lucia",
    value: "St. Lucia"
  },
  {
    text: "St. Martin",
    value: "St. Martin"
  },
  {
    text: "St. Pierre & Miquelon",
    value: "St. Pierre & Miquelon"
  },
  {
    text: "St. Vincent & Grenadines",
    value: "St. Vincent & Grenadines"
  },
  {
    text: "Sudan",
    value: "Sudan"
  },
  {
    text: "Suriname",
    value: "Suriname"
  },
  {
    text: "Svalbard & Jan Mayen",
    value: "Svalbard & Jan Mayen"
  },
  {
    text: "Sweden",
    value: "Sweden"
  },
  {
    text: "Switzerland",
    value: "Switzerland"
  },
  {
    text: "Syria",
    value: "Syria"
  },
  {
    text: "Taiwan",
    value: "Taiwan"
  },
  {
    text: "Tajikistan",
    value: "Tajikistan"
  },
  {
    text: "Tanzania",
    value: "Tanzania"
  },
  {
    text: "Thailand",
    value: "Thailand"
  },
  {
    text: "Timor-Leste",
    value: "Timor-Leste"
  },
  {
    text: "Togo",
    value: "Togo"
  },
  {
    text: "Tokelau",
    value: "Tokelau"
  },
  {
    text: "Tonga",
    value: "Tonga"
  },
  {
    text: "Trinidad & Tobago",
    value: "Trinidad & Tobago"
  },
  {
    text: "Tunisia",
    value: "Tunisia"
  },
  {
    text: "Turkey",
    value: "Turkey"
  },
  {
    text: "Turkmenistan",
    value: "Turkmenistan"
  },
  {
    text: "Turks & Caicos Islands",
    value: "Turks & Caicos Islands"
  },
  {
    text: "Tuvalu",
    value: "Tuvalu"
  },
  {
    text: "U.S. Outlying Islands",
    value: "U.S. Outlying Islands"
  },
  {
    text: "Uganda",
    value: "Uganda"
  },
  {
    text: "Ukraine",
    value: "Ukraine"
  },
  {
    text: "United Arab Emirates",
    value: "United Arab Emirates"
  },
  {
    text: "United Kingdom",
    value: "United Kingdom"
  },
  {
    text: "United States",
    value: "United States"
  },
  {
    text: "Uruguay",
    value: "Uruguay"
  },
  {
    text: "Uzbekistan",
    value: "Uzbekistan"
  },
  {
    text: "Vanuatu",
    value: "Vanuatu"
  },
  {
    text: "Vatican City",
    value: "Vatican City"
  },
  {
    text: "Venezuela",
    value: "Venezuela"
  },
  {
    text: "Vietnam",
    value: "Vietnam"
  },
  {
    text: "Wallis & Futuna",
    value: "Wallis & Futuna"
  },
  {
    text: "Western Sahara",
    value: "Western Sahara"
  },
  {
    text: "Yemen",
    value: "Yemen"
  },
  {
    text: "Zambia",
    value: "Zambia"
  },
  {
    text: "Zimbabwe",
    value: "Zimbabwe"
  }
];
